import React, { useContext, useState } from 'react';
import { string, func } from 'prop-types';
import classNames from 'classnames/bind';
import Cookies from 'universal-cookie';

import { StaticTextContext } from 'context/StaticTextContext';

import styles from './WarningPopin.module.scss';
const cx = classNames.bind(styles);
const cookies = new Cookies();

const WarningPopin = ({ className, hidePopin }) => {
  const [disabledButton, setDisabledButton] = useState();
  const { labels } = useContext(StaticTextContext);

  const setCoookies = () => {
    hidePopin();

    // Cookie max age date  3600 * 24 * 365 (seconds * hours * days) = 31536000
    cookies.set('taTermsAgreement', 1, { maxAge: 31536000, path: '/' });
  };

  const setButtonState = () => {
    const status = document.getElementById('terms-agreement').checked;
    setDisabledButton(!status);
  };

  return (
    <div className={cx('root', className)}>
      <div className={cx('popin-bg')} />
      <section className={cx('content')}>
        <h3 className={cx('title')}>{labels.warningPopinTitle}</h3>
        <div className={cx('description')}>
          {labels.warningPopinDescription}
        </div>
        <div className={cx('checkbox-wrap')}>
          <input
            className={cx('checkbox')}
            type="checkbox"
            name="termsAgreement"
            id="terms-agreement"
            onChange={setButtonState}
          />
          <label className={cx('label')} htmlFor="terms-agreement">
            {labels.warningPopinLabelText}{' '}
            <a
              href={labels.warningPopinLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {labels.warningPopinTermsText}
            </a>
          </label>
        </div>
        <button
          className={cx('btn')}
          type="button"
          onClick={setCoookies}
          disabled={disabledButton}
        >
          {labels.warningPopinButtonLabel}
        </button>
      </section>
    </div>
  );
};

WarningPopin.propTypes = {
  hidePopin: func.isRequired,
  className: string,
};

WarningPopin.defaultProps = {
  className: null,
};

export default WarningPopin;



// WEBPACK FOOTER //
// ./src/components/WarningPopin/WarningPopin.js